import { el } from "../lib/dom";
import { getGame } from "../games/registry";
import { getGameProgress, getLevelRecord, isLevelUnlocked } from "../lib/storage";
import { starRow } from "./components";
import { navigate } from "./router";
import type { Screen } from "./home";

export function levelSelectScreen(gameId: string): Screen {
  const game = getGame(gameId);
  if (!game) {
    return { node: el("div.screen", {}, el("p", {}, "Onbekend spel."), backBtn()) };
  }

  const header = el(
    "header.app-header",
    {},
    backBtn(),
    el("div.level-header-title", {}, game.title),
    el("span.coins", {}, `★ ${totalStars(gameId)}`),
  );

  // Endless games show the unlocked levels plus a horizon of locked ones; more
  // appear automatically as the player progresses.
  const endless = !Number.isFinite(game.levelCount);
  const shown = endless
    ? Math.max(20, getGameProgress(gameId).highestUnlocked + 10)
    : game.levelCount;

  const grid = el("div.level-grid");
  for (let n = 1; n <= shown; n++) {
    const unlocked = isLevelUnlocked(gameId, n);
    const rec = getLevelRecord(gameId, n);
    const tile = el(
      `button.level-tile${unlocked ? "" : ".locked"}${rec?.completed ? ".done" : ""}`,
      {
        disabled: !unlocked,
        style: `--accent:${game.accent}`,
        onclick: unlocked ? () => navigate(`/g/${gameId}/${n}`) : undefined,
        "aria-label": `Level ${n}`,
      },
      unlocked ? el("span.level-num", {}, String(n)) : el("span.level-lock", {}, "🔒"),
    );
    if (unlocked && rec?.completed) tile.append(starRow(rec.stars, 3, "0.7rem"));
    grid.append(tile);
  }

  const node = el("div.screen.levelselect-screen", { style: `--accent:${game.accent}` }, header, grid);
  if (endless) node.append(el("p.footer-note", {}, "Oneindig veel levels — er komen er steeds meer bij!"));
  return { node };
}

function totalStars(gameId: string): number {
  let s = 0;
  for (const rec of Object.values(getGameProgress(gameId).levels)) s += rec.stars ?? 0;
  return s;
}

function backBtn(): HTMLElement {
  return el("button.icon-btn", { onclick: () => navigate("/"), "aria-label": "Terug" }, "‹");
}
